import { RouteEnum } from "core/enum/route.enum";
import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";

interface IPropTypes {
  cell: {
    row: {
      original: any;
    };
  };
}

const Actions: React.FC<IPropTypes> = ({
  cell: {
    row: { original },
  },
}) => {
  const history = useHistory();
  return (
    <div className="d-flex justify-content-center align-content-center">
      <Button
        size="sm"
        color={"warning"}
        // onClick={() => history.push(`/user-orders/${original.id}`)}
        onClick={() =>
          history.push(
            RouteEnum.UserOrderDetails.replace(":id", String(original.id)),
          )
        }
      >
        جزئیات
      </Button>
    </div>
  );
};

export { Actions };
